/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Просмотр справочника ГРУПП категорий продуктов - первый уровень.
 */
export interface ViewLoyaltyCategory { 
    /**
     * связь с таблицей LoyaltyCategoryGroups
     */
    loyaltyCategoryGroupId?: string;
    /**
     * Наименование категории.
     */
    name: string;
    /**
     * Описание категории.
     */
    description?: string;
    /**
     * ID фотографии/иконки.
     */
    iconId?: string;
    /**
     * Сортировка.
     */
    sortOrder?: number;
    /**
     * ID записи.
     */
    id?: string;
    /**
     * Используется.
     */
    inUse?: boolean;
}

